{
  "FILTER": {
    "TITLE": "Filtriraj pogovore",
    "SUBTITLE": "Spodaj dodajte svoje filtre in pritisnite »Uporabi filtre«, da presežete nered v klepetu.",
    "EDIT_CUSTOM_FILTER": "Uredi mapo",
    "CUSTOM_VIEWS_SUBTITLE": "Dodajte ali odstranite filtre in posodobite svojo mapo.",
    "ADD_NEW_FILTER": "Dodaj filter",
    "FILTER_DELETE_ERROR": "Ups, izgleda, da ne moremo shraniti ničesar! Dodajte vsaj en filter, da ga shranite.",
    "SUBMIT_BUTTON_LABEL": "Uporabi filtre",
    "UPDATE_BUTTON_LABEL": "Posodobi mapo",
    "CANCEL_BUTTON_LABEL": "Prekliči",
    "CLEAR_BUTTON_LABEL": "Odstrani filtre",
    "FOLDER_LABEL": "Ime mape",
    "TEAMS_LABEL": "Deli z",
    "PARENT_FOLDER_LABEL": "Nadrejena mapa",
    "NO_PARENT_FOLDER": "Brez nadrejene mape",
    "COLOR_LABEL": "Barva",
    "SELECT_COLOR": "Izberite barvo",
    "CLEAR_SELECTION": "Počisti izbiro",
    "SORT_BY_LABEL": "Razvrsti po",
    "FOLDER_QUERY_LABEL": "Poizvedba mape",
    "EMPTY_VALUE_ERROR": "Vrednost je obvezna.",
    "TOOLTIP_LABEL": "Filtriraj pogovore",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "IN",
      "OR": "ALI"
    },
    "INPUT_PLACEHOLDER": "Vnesite vrednost",
    "OPERATOR_LABELS": {
      "present": "Prisoten",
      "not_present": "Ni prisoten",
      "present_with_answer": "Prisoten z odgovorom",
      "present_without_answer": "Prisoten brez odgovora",
      "equal_to": "Enako",
      "not_equal_to": "Ni enako",
      "does_not_contain": "Ne vsebuje",
      "is_present": "Je prisoten",
      "is_not_present": "Ni prisoten",
      "is_greater_than": "Je večje od",
      "is_less_than": "Je manjše od",
      "is_greater_than_or_equal": "Je večje ali enako",
      "is_less_than_or_equal": "Je manjše ali enako",
      "newer_than_days": "Je novejše od x dni (vključno)",
      "older_than_days": "Je starejše od x dni (vključno)",
      "starts_with": "Začne se z",
      "equalTo": "Enako",
      "notEqualTo": "Ni enako",
      "contains": "Vsebuje",
      "doesNotContain": "Ne vsebuje",
      "isPresent": "Je prisoten",
      "isNotPresent": "Ni prisoten",
      "isGreaterThan": "Je večje od",
      "isLessThan": "Je manjše od",
      "startsWith": "Začne se z"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "True",
      "FALSE": "False"
    },
    "ATTRIBUTES": {
      "STATUS": "Status",
      "ASSIGNEE_NAME": "Ime prejemnika",
      "INBOX_NAME": "Ime nabiralnika",
      "TEAM_NAME": "Ime ekipe",
      "CONVERSATION_IDENTIFIER": "Identifikator pogovora",
      "CAMPAIGN_NAME": "Ime kampanje",
      "LABELS": "Označbe",
      "BROWSER_LANGUAGE": "Jezik brskalnika",
      "PRIORITY": "Prioriteta",
      "COUNTRY_NAME": "Ime države",
      "REFERER_LINK": "Napotitvena povezava",
      "CUSTOM_ATTRIBUTE_LIST": "Seznam",
      "CUSTOM_ATTRIBUTE_TEXT": "Tekst",
      "CUSTOM_ATTRIBUTE_NUMBER": "Številka",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Potrditveno polje",
      "CREATED_AT": "Ustvarjeno ob",
      "LAST_ACTIVITY": "Zadnja aktivnost",
      "LAST_CUSTOMER_MESSAGE_AT": "Zadnje sporočilo stranke",
      "PHONE_CALL": "Telefonski klic",
      "RATING": "Ocena",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Dohodni",
      "OUTBOUND": "Odhodni",
      "MISSED": "Zgrešen",
      "UNHANDLED_MISSED": "Neobravnavan zgrešen"
    },
    "RATING_TYPES": {
      "UP": "Palec gor",
      "DOWN": "Palec dol"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Vrednost je obvezna",
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Vrednost mora biti med 0 in 998",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standardni filtri",
      "ADDITIONAL_FILTERS": "Dodatni filtri",
      "CUSTOM_ATTRIBUTES": "Atributi po meri"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Ali želite shraniti ta filter?",
        "LABEL": "Poimenujte ta filter",
        "PLACEHOLDER": "Poimenujte svoj filter, da ga uporabite pozneje.",
        "ERROR_MESSAGE": "Ime je obvezno.",
        "SAVE_BUTTON": "Shrani filter",
        "CANCEL_BUTTON": "Prekliči",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Mapa je bila uspešno ustvarjena.",
          "ERROR_MESSAGE": "Napaka pri ustvarjanju mape."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment je bil uspešno ustvarjen.",
          "ERROR_MESSAGE": "Napaka pri ustvarjanju segmenta."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Uredi mapo",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Napaka pri posodabljanju mape."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Izbriši filter",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Potrdite izbris",
            "MESSAGE": "Ali ste prepričani, da želite izbrisati filter?",
            "YES": "Da, izbriši",
            "NO": "Ne, obdrži"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Mapa je bila uspešno izbrisana.",
          "ERROR_MESSAGE": "Napaka pri brisanju mape."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment uspešno izbrisan.",
          "ERROR_MESSAGE": "Napaka pri brisanju segmenta."
        }
      }
    }
  }
}
